var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.553 7.003c.55.49.6 1.332.11 1.883l-14.222 16a1.333 1.333 0 0 1-1.993 0l-7.111-8a1.333 1.333 0 0 1 1.993-1.772l6.115 6.879L25.67 7.114c.49-.55 1.332-.6 1.882-.11"
  })));
};
export default SvgCheck;